var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"odontograma",attrs:{"id":"div_odontograma"}},[_c('div',{staticClass:"vertical"}),_c('div',{staticClass:"horizontal"}),_vm._l((_vm.quadrantesArray(_vm.tipoDenticao)),function(quadrante){return _c('div',_vm._b({key:quadrante,staticClass:"quadrante"},'div',{
            id    : 'q' + quadrante,
            style : { 
                justifyContent   : ((quadrante % 2) == 0) ? 'start' : 'end',
                gridTemplateRows : (_vm.tipoDenticao == _vm.gConsts.denticao.PERMANTENTE) ? 'auto auto' : 'auto auto auto auto'
            }
        },false),_vm._l((_vm.children.filter(node => _vm.denteInQuadrante(parseInt(node.layout.label, 10), quadrante))),function(dente){return _c('div',_vm._b({key:dente.layout.label,on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(dente)}}},'div',{
                id         : dente.id,
                background : dente.layout.color,
                class : {
                    denteLabel   : true,
                    selDente     : _vm.isNodeActive(dente),
                }
            },false),[_c('div',_vm._b({},'div',{
                    id    : dente.id + '_color',
                    style : {
                        display    : 'inline-block',
                        height     : '7px',
                        background : dente.layout.color,
                        denteAusente : !_vm.dentePresente(dente)
                    },
                    class : {
                        labelColor : true,
                        denteAusente : !_vm.dentePresente(dente)
                    }
                },false)),_c('div',_vm._b({},'div',{
                    id : dente.id + '_text',
                    class : {
                        labelText : true,
                        denteAusente : !_vm.dentePresente(dente)
                    }                        
                },false),[_vm._v(" "+_vm._s(dente.layout.label)+" ")])])}),0)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }